import { validationRules } from '../../../../../services/validation/rules/validationRules'
import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConnections,
  defaultConstruction,
  defaultContactInfo,
  defaultCosts,
  defaultDescription,
  defaultOfficeBasicInfo,
  defaultOfficeRentOtherFacilities,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'

export const propertyOwnerOfficeRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: defaultOfficeBasicInfo,
  costs: defaultCosts,
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  contactInfo: defaultContactInfo,
  otherFacilities: defaultOfficeRentOtherFacilities,
  connections: defaultConnections,
  construction: defaultConstruction,
}
